module.exports = {"511502006":"西郊街道","511502007":"安阜街道","511502008":"白沙湾街道","511502010":"象鼻街道","511502011":"沙坪街道","511502012":"合江门街道","511502013":"大观楼街道","511502014":"双城街道","511502101":"李庄镇","511502102":"菜坝镇","511502104":"金坪镇","511502108":"牟坪镇","511502109":"李端镇","511502111":"宗场镇","511502112":"宋家镇","511502115":"思坡镇","511502116":"白花镇","511502118":"双谊镇","511502120":"永兴镇","511502121":"金秋湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511502.json
// module id = 2486
// module chunks = 0